import { useState } from 'react';

export const Tooltip = ({ children, content, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 border-t-foreground',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-foreground',
    left: 'left-full top-1/2 -translate-y-1/2 border-l-foreground',
    right: 'right-full top-1/2 -translate-y-1/2 border-r-foreground',
  };

  return (
    <div 
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && content && (
        <div 
          className={`absolute ${positionClasses[position]} px-3 py-2 bg-foreground text-background text-xs rounded-lg whitespace-nowrap z-50 animate-fade-in`}
          style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)' }}
        >
          {content}
          <div 
            className={`absolute ${arrowClasses[position]} border-4 border-transparent`}
            style={{ 
              [position === 'top' ? 'borderTopColor' : 
               position === 'bottom' ? 'borderBottomColor' :
               position === 'left' ? 'borderLeftColor' : 'borderRightColor']: 'hsl(var(--foreground))' 
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
